var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSaveEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5022 4.86419C1.19048 4.50793 0.648967 4.47183 0.292706 4.78356C-0.0635538 5.09529 -0.0996542 5.6368 0.212073 5.99306L3.21207 9.42163C3.54498 9.8021 4.13317 9.81328 4.48029 9.44573L11.766 1.73145C12.091 1.38729 12.0755 0.844796 11.7314 0.519758C11.3872 0.194719 10.8447 0.210219 10.5197 0.554377L3.88135 7.58322L1.5022 4.86419Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSaveEmail);
export default __webpack_public_path__ + "static/media/ArrowSaveEmail.4d153d8c91d6c450f4efb03e1e302752.svg";
export { ForwardRef as ReactComponent };